import React from "react";


function Comment({ comment }) {

    var today = new Date(comment.attributes.created);

    return (
        <div className="card mt-5">
            <div className="card-body">
                <h5 class="card-title">{comment.attributes.subject}</h5>
                <p className="card-text">{comment.attributes.comment_body.value}</p>
                <p className="card-text">
                    <small className="text-muted">
                        {`${today.getDate()}-${today.getMonth() + 1}-${today.getFullYear()}`}
                    </small>
                </p>
            </div>
        </div>
    )

}

export default Comment